import { Box, ButtonBase, Stack } from '@razz-team/ui-web';
import { Outlet } from '@tanstack/react-router';
import { AppLogo } from '../../Logo/AppLogo';
import { AppLayout } from '../../Layout/AppLayout';

export function ThreeDSLayout() {
  return (
    <AppLayout>
      <Stack width="100%" height="100%" paddingX={2} paddingY={8}>
        <Stack direction="row" justifyContent="start" width="100%">
          <ButtonBase href="/">
            <AppLogo size={40} />
          </ButtonBase>
        </Stack>
        <Stack width="100%" height="100%" alignItems="center" justifyContent="center">
          <Box width="100%" maxWidth={600}>
            <Outlet />
          </Box>
        </Stack>
      </Stack>
    </AppLayout>
  );
}
